import { FC, useMemo } from "react";
import ControlledSelect, { ControlledSelectProps } from "../../../ControlledInputs/ControlledSelect.tsx";
import { useWatch } from "react-hook-form";

const CountSelect: FC<Omit<ControlledSelectProps, "options" | "disabled"> & { onOptionsChange?: () => void; }> = (props) => {
  const options = useMemo(() => {
    return [
      { "label": "0.5 год", "value": 0.5 },
      { "label": "1 год", "value": 1 },
      { "label": "1.5 год", "value": 1.5 },
      { "label": "2 год", "value": 2 },
      { "label": "2.5 год", "value": 2.5 },
      { "label": "3 год", "value": 3 },
      { "label": "3.5 год", "value": 3.5 },
      { "label": "4 год", "value": 4 },
      { "label": "4.5 год", "value": 4.5 },
      { "label": "5 год", "value": 5 },
      { "label": "5.5 год", "value": 5.5 },
      { "label": "6 год", "value": 6 },
      { "label": "6.5 год", "value": 6.5 },
      { "label": "7 год", "value": 7 },
      { "label": "7.5 год", "value": 7.5 },
      { "label": "8 год", "value": 8 },
      { "label": "8.5 год", "value": 8.5 },
      { "label": "9 год", "value": 9 },
      { "label": "9.5 год", "value": 9.5 },
      { "label": "10 год", "value": 10 },
      { "label": "10.5 год", "value": 10.5 },
      { "label": "11 год", "value": 11 },
      { "label": "11.5 год", "value": 11.5 },
      { "label": "12 год", "value": 12 },
    ];
  }, []);

  const date = useWatch({
    control: props.control,
    name: "date",
  });

  return (
    <ControlledSelect key={date} disabled={!date} options={options} {...props} />
  );
};

export default CountSelect;
